module.exports = __webpack_public_path__ + "static/media/lake.90d2b64c.jpg";